import { MedNotificationPositions } from "../types";

export const medNotificationItemPositionMap = new Map<MedNotificationPositions, string>()
  .set("bottom-right", "end")
  .set("top-right", "end")
  .set("bottom-left", "start")
  .set("top-left", "start")
  .set("bottom", "center")
  .set("top", "center");

